// 站内信, as the navbar's bell and the 消息中心 share it: the unread count
// and the newest few. The bell refreshes it every two minutes and when
// opened; the 消息中心 after each change, so the two never disagree.
// The same file in both consoles.
import { reactive } from 'vue'
import { api, type InboxItem } from '@/api/client'

/** How many the bell lists. */
export const RECENT = 5

export const inbox = reactive({ unread: 0, recent: [] as InboxItem[], loaded: false })

export async function loadInbox() {
  const p = await api.notifications({ page: 1, page_size: RECENT })
  inbox.unread = p.unread
  inbox.recent = p.items
  inbox.loaded = true
}

/** Marks ids read — every unread one when empty — here and on the server. */
export async function markRead(ids: number[]) {
  const { unread } = await api.readNotifications(ids)
  const now = new Date().toISOString()
  for (const n of inbox.recent) if (!n.read_at && (!ids.length || ids.includes(n.id))) n.read_at = now
  inbox.unread = unread
}

/**
 * A page that shows what its 站内信 are about — a ticket — reads them:
 * every unread one linking to it is marked read, so the bell does not go
 * on telling what is on the screen.
 */
export async function markReadByLink(link: string) {
  try {
    const p = await api.notifications({ unread: true, page: 1, page_size: 100 })
    const ids = p.items.filter((n) => n.link === link).map((n) => n.id)
    if (ids.length) await markRead(ids)
  } catch {
    // The bell just goes on counting them.
  }
}

/** The 消息中心 changed something the bell shows: read it again. */
export function refreshInbox() {
  void loadInbox().catch(() => {})
}
